import SecureResidenceSubFrame from './SecureResidenceSubFrame';
import { panelByFrameId } from '../../utils/secureResidenceFlow';

const panel = panelByFrameId('frame-38')!;

export default function Frame38() {
  return <SecureResidenceSubFrame panel={panel} />;
}
